import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionSelectOne } from '../../../../../graphql/generated/graphql';
import { AfterValueText, BeforeValueText } from '../../../primitive/DiffText';

interface Props {
  field: Pick<DynamicSchemaDefinitionSelectOne, 'key'>;
  value: {
    values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  };
  beforeValue?: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
}

const AsSelectOne = ({ field, value, beforeValue }: Props) => {
  const isAllowLeaveToTheCreatorsKey = value.values.get(field.key) as string;
  const beforeIsAllowLeaveToTheCreatorsKey = beforeValue?.get(field.key) as string | null;

  return (
    <Fragment>
      {(beforeValue == null || isAllowLeaveToTheCreatorsKey === beforeIsAllowLeaveToTheCreatorsKey) &&
      (isAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' || isAllowLeaveToTheCreatorsKey === 'unnecessary') ? (
        <Typography color="primary" variant="subtitle2">
          <FormattedMessage
            id={`project_basic_setting_detail.assets.label.leave_to_the_creators.${isAllowLeaveToTheCreatorsKey}_text`}
          />
          {isAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' && (
            <Fragment>
              <br />
              <FormattedMessage id="project_basic_setting_detail.assets.label.leave_to_the_creators.note" />
            </Fragment>
          )}
        </Typography>
      ) : (
        <Fragment>
          {beforeValue != null &&
            beforeIsAllowLeaveToTheCreatorsKey != null &&
            (beforeIsAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' ||
              beforeIsAllowLeaveToTheCreatorsKey === 'unnecessary') && (
              <BeforeValueText>
                <FormattedMessage
                  id={`project_basic_setting_detail.assets.label.leave_to_the_creators.${beforeIsAllowLeaveToTheCreatorsKey}_text`}
                />
                {beforeIsAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' && (
                  <Fragment>
                    <br />
                    <FormattedMessage id="project_basic_setting_detail.assets.label.leave_to_the_creators.note" />
                  </Fragment>
                )}
              </BeforeValueText>
            )}
          {beforeValue != null &&
            (isAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' ||
              isAllowLeaveToTheCreatorsKey === 'unnecessary') && (
              <AfterValueText>
                <FormattedMessage
                  id={`project_basic_setting_detail.assets.label.leave_to_the_creators.${isAllowLeaveToTheCreatorsKey}_text`}
                />
                {isAllowLeaveToTheCreatorsKey === 'leave_to_the_creators' && (
                  <Fragment>
                    <br />
                    <FormattedMessage id="project_basic_setting_detail.assets.label.leave_to_the_creators.note" />
                  </Fragment>
                )}
              </AfterValueText>
            )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default AsSelectOne;
